<template>
  <a-modal
    v-model="show"
    :width="620"
    title="关于运费余额"
  >
    <div class="flex">
      <div>
        <div class="fs-20 fs-b">
          什么是运费余额
        </div>
        <div class="mt-10 fslh-24 pr-20">
          由公司管理员预付一定运费，<br>
          所有员工对公寄件，运费余额自动支付，<br>
          享受，在线支付运费7.5折，<br>
          享受，同城寄件6元起，<br>
          享受，统一记账和费用管理。
        </div>
      </div>
      <div class="w-300">
        <img class="w-100p" src="@/assets/index/ftips@2x.png" alt="">
      </div>
    </div>

    <div slot="footer">
      <a-button type="primary" @click="show = false">好的，我知道了</a-button>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    viz: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: this.viz
    }
  },
  watch: {
    show(n) {
      this.$emit('update:viz', n)
    },
    viz(n) {
      this.show = n
    }
  }
}
</script>
<style lang="scss" scoped>
.c-tips{
    position: relative;
    .close{
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
}
</style>
